import api from '../Axios'; 

export interface OnboardingStatus {
  // We can remove 'id' from here too if you want to be strictly public-only
  // but it doesn't hurt to keep it in the type definition for now.
  id?: string; 
  expert_code: string;
  full_name: string;
  email: string;
  phone?: string;  
  category_id?: string; 
  
  // Account Status
  account_status: string;
  is_registration_step1_completed: boolean;
  
  // Doctor Steps
  is_doctor_step2_completed: boolean;
  is_doctor_step3_completed: boolean;
  is_doctor_step4_completed: boolean;
  is_doctor_step5_completed: boolean;
  is_doctor_final_step_completed: boolean;

  // Lawyer Steps
  is_lawyer_step2_completed: boolean;
  is_lawyer_final_step_completed: boolean;

  // Astrology Steps
  is_astrology_final_step_completed: boolean;
}

// 🟢 FIXED: Variable renamed to 'expertCode' to match reality
export const getOnboardingStatus = async (expertCode: string) => {
  // The URL remains the same structure, but now we know we are passing "EXP110" 
  // instead of a UUID. Ensure your Backend Controller expects this!
  return api.get<OnboardingStatus>(`/api/experts/${expertCode}/onboarding-status`);
};